import { PriceTrackers, TrackerType } from '@vae/server/dist/client'

export const getSortedTrackers = (trackers: PriceTrackers[]) => {
	const getOrder = (trackerType: TrackerType): number => {
		switch (trackerType) {
			case 'veryHigh':
				return 1
			case 'high':
				return 2
			case 'low':
				return 3
			case 'veryLow':
				return 4
			default:
				return 5
		}
	}

	return trackers.sort((a, b) => {
		return getOrder(a.limitType) - getOrder(b.limitType)
	})
}
